import axios from 'axios';

const endpoints = {
  getPricing: 'pricing/'
}

function getSpecialOffers (baseUrl, dealerId) {
  var url = baseUrl + endpoints.getPricing + `incentives/?dealerId=${dealerId}`
  return axios.get(url)
}

export { getSpecialOffers }
